import * as React from 'react';

interface IProps {
  showSpinner: boolean;
}

export const SpinnerComponent: React.StatelessComponent<IProps> = (props) => {
  return (
    props.showSpinner ?
      <div>
        <div className="spinnerOverlay" />
        <div className="spinner">
          <span>Ladataan sisältöä...</span>
        </div>
      </div> :
      null
  );
};


// WEBPACK FOOTER //
// ./src/common/components/spinner/spinner.tsx